import { configureStore } from '@reduxjs/toolkit';
import counterReducer from '../example/reduxSlice';
import allModelsReducer from '../components/AllThreeDModels/reduxSlice'

export const store = configureStore({
  reducer: {
    // redux example
    counter: counterReducer,
    allModels: allModelsReducer
  },
});
